import { getFirebaseApp } from '../firebase'

export const callCloudFunctionsBFF = async (functionName: string) => {
  const { functions } = await getFirebaseApp()
  return functions.httpsCallable(functionName)
}
